


























































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

import { config } from './config';
import { locales } from './locales';

import { required } from '../../rules/required';

import { customizable } from '../../mixins/customizable';
import { Widthable } from '../../mixins/widthable';

import { UploadWorkflowCore } from './mixins/uploadWorkflowCore';

import FileList from './FileList';

const Props = Vue.extend({
	props: {
		/** The main title */
		sectionTitle: {
			type: String,
			default: undefined
		}
	}
});

const MixinsDeclaration = mixins(Props, customizable(config), UploadWorkflowCore, Widthable);

/**
 * UploadWorkflow is a component that let the user select files
 * and define a type for them in a pre-defined list
 */
@Component<UploadWorkflow>({
	components: {
		FileList
	},
	model: {
		prop: 'value',
		event: 'change'
	}
})
export default class UploadWorkflow extends MixinsDeclaration {
	// Locales
	locales = locales;

	/** The rules for the select in the dialog */
	selectRules = [
		required
	];

	get computedTitle(): string {
		if (this.sectionTitle) {
			return this.sectionTitle;
		} else {
			const plural = this.value.length > 1;

			return locales.title(plural);
		}
	}

	/** Prefill the select and click on FileUpload */
	showFileUpload(id: string): void {
		// Prefill the select
		this.selectedItem = id;
		this.$refs.fileUpload.retry();
	}
}
